(function ($) {
	function createFocusOrderHandler($widget) {
		var KEY_COMMANDS = {
			UP: 38,
			DOWN: 40,
			TAB: 9
		};
		var widgetItemIndex = -1;
		var $focusableElements = $('#main-content')
			.find('.js-focus-order, a[href]:not(.js-focus-order-item), button, input');
		var $nextFocusElement;

		function init() {
			$widget.on('focus', handleFocus);
		}

		function handleFocus() {
			$widget.addClass('has-focus');
			$widget.on('keydown', handleKeyDown);
			var $activeElement = document.activeElement;

			for (var i = 0; i < $focusableElements.length; i++) {
				if ($focusableElements[i] === $activeElement) {
					$nextFocusElement = $focusableElements[i+1];
					break;
				}
			}
		}

		function handleKeyDown(e) {
			var keyCode = e.keyCode;

			if (shouldHandleKeyDown(keyCode) === false) {
				return;
			}

			if ($widget.hasClass('has-focus')) {
				var $widgetItems = $widget.find('.js-focus-order-item');

				var setFocus = function () {
					e.preventDefault();

					var $currentWidgetItem = $($widgetItems[widgetItemIndex]);
					$currentWidgetItem.focus();
				};

				switch (keyCode) {
					case KEY_COMMANDS.UP:
						handleUpKey($widgetItems);
						break;
					case KEY_COMMANDS.DOWN:
						handleDownKey($widgetItems);
						break;
					case KEY_COMMANDS.TAB:
						handleTabKey();
						break;
				}

				setFocus();
			}
		}

		function handleUpKey($widgetItems) {
			if (widgetItemIndex > -1) {
				widgetItemIndex--;
			}
			else if (widgetItemIndex === -1) {
				widgetItemIndex = $widgetItems.length - 1;
			}
		}

		function handleDownKey($widgetItems) {
			if (widgetItemIndex < $widgetItems.length - 1) {
				widgetItemIndex++;
			} else if (widgetItemIndex === $widgetItems.length - 1) {
				widgetItemIndex = -1;
			}
		}

		function handleTabKey() {
			$('.js-focus-order').removeClass('has-focus');
			$widget.off('keydown');
			$nextFocusElement.focus();
		}

		function shouldHandleKeyDown(keyCode) {
			var shouldHandleKey = Object.keys(KEY_COMMANDS).some(function (keyCodeToHandle) {
				return KEY_COMMANDS[keyCodeToHandle] === keyCode;
			});

			if (shouldHandleKey === false) {
				return false;
			}
		}

		init();
	}

	$('.js-focus-order').each(function() {
		createFocusOrderHandler($(this));
	});
})(jQuery);
